"use client";

import Link from "next/link";
import { track } from "../../../lib/analytics";

// Last conversion surface on the landing page. Layered charcoal so the
// page closes on the same tone it opened on. Single CTA. No secondary
// distractions.
export default function FinalCta() {
  return (
    <section className="bg-maren-charcoal text-maren-stone">
      <div className="max-w-4xl mx-auto px-6 py-20 sm:py-24 text-center">
        <h2 className="font-display font-medium tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.15]">
          The MCAT does not get easier. Knowing what to work on does.
        </h2>
        <p className="mt-5 max-w-xl mx-auto text-base sm:text-lg text-maren-stone/75 leading-relaxed">
          Log every miss for free. When you want Maren to find the pattern, full access is one payment away.
        </p>
        <Link
          href="/signup"
          onClick={() => track({ name: "cta_click", props: { location: "final_cta" } })}
          className="mt-10 inline-flex items-center justify-center rounded-lg bg-maren-green hover:bg-maren-green/90 active:bg-maren-green/80 px-7 py-3.5 text-sm sm:text-base font-semibold text-maren-stone shadow-sm hover:shadow-md transition focus:outline-none focus:ring-2 focus:ring-maren-gold/50 focus:ring-offset-2 focus:ring-offset-maren-charcoal"
        >
          Start Free
        </Link>
        <p className="mt-4 text-[13px] text-maren-stone/60">
          The tracker is free forever. No card required.
        </p>
      </div>
    </section>
  );
}
